import { WebStorageStateStore } from "oidc-client-ts";
import { OIDC_CLIENT_ID, REALMS } from "@/constants/process";
import type { RealmSliceState } from "@/store/realm-slice";

const evcoreUserManagerConfig = {
  authority: `${process.env.NEXT_PUBLIC_KEYCLOAK_URL}/realms/${REALMS.EVCORE}`,
  client_id: OIDC_CLIENT_ID,
};

const evbasicUserManagerConfig = {
  authority: `${process.env.NEXT_PUBLIC_KEYCLOAK_URL}/realms/${REALMS.EVBASIC}`,
  client_id: OIDC_CLIENT_ID,
};

export function getUserManagerConfig(realm: RealmSliceState["realm"]) {
  // Why are the config keys using `window` set here?
  // Because this function is only run in the client
  const baseUserManagerConfig = {
    redirect_uri: `${window.origin}/auth/callback/signin`,
    post_logout_redirect_uri: `${window.origin}/auth/callback/signout`,
    userStore: new WebStorageStateStore({ store: window.localStorage }),
  };
  if (realm === REALMS.EVCORE) {
    return {
      ...baseUserManagerConfig,
      ...evcoreUserManagerConfig,
    };
  }
  if (realm === REALMS.EVBASIC) {
    return {
      ...baseUserManagerConfig,
      ...evbasicUserManagerConfig,
    };
  }
  return {
    ...baseUserManagerConfig,
    ...evcoreUserManagerConfig,
  };
}
